(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // ---- FAQ accordion ----
  document.addEventListener("click", function (e) {
    var q = e.target.closest(".faq-q");
    if (!q) return;
    var item = q.closest(".faq-item");
    var ans = item.querySelector(".faq-a");
    var open = item.classList.toggle("is-open");
    ans.style.maxHeight = open ? ans.scrollHeight + "px" : null;
    q.setAttribute("aria-expanded", open ? "true" : "false");
  });

  // ---- Bundle selector (variant based) ----
  document.addEventListener("change", function (e) {
    if (!e.target.matches('.bundle input[type="radio"]')) return;
    var group = e.target.closest(".bundles");
    group.querySelectorAll(".bundle").forEach(function (b) { b.classList.remove("is-active"); });
    e.target.closest(".bundle").classList.add("is-active");
    var form = e.target.closest("form");
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = e.target.value;
    }
    // Ana sayfada form yok: buton ürün sayfasına giden bir bağlantı.
    // Seçilen paket bağlantıdaki varyanta yansısın.
    var scope = e.target.closest(".hm-buy-form, .buy, section") || document;
    var buyLink = scope.querySelector("[data-buy-link]");
    if (buyLink) {
      buyLink.href = buyLink.href.split("?")[0] + "?variant=" + e.target.value;
    }
    syncBuyBar();
  });

  // ---- Reveal on scroll ----
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });

  // ---- Scroll progress bar ----
  var bar = document.createElement("div");
  bar.className = "scroll-progress";
  document.body.appendChild(bar);
  function onScroll() {
    var h = document.documentElement;
    var p = h.scrollTop / (h.scrollHeight - h.clientHeight);
    bar.style.width = (p * 100) + "%";
    toggleBuyBar();
  }
  window.addEventListener("scroll", onScroll, { passive: true });

  // ---- Count-up numbers ----
  function countUp(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var dec = (el.getAttribute("data-count").split(".")[1] || "").length;
    if (reduce) { el.textContent = target.toFixed(dec); return; }
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var prog = Math.min((ts - start) / dur, 1);
      var val = (target * (0.2 + 0.8 * prog)); // ease-ish
      el.textContent = (prog < 1 ? val : target).toFixed(dec);
      if (prog < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var countIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { countUp(en.target); countIO.unobserve(en.target); }
    });
  }, { threshold: 0.6 });
  document.querySelectorAll("[data-count]").forEach(function (el) { countIO.observe(el); });

  // ---- Sticky mobile buy bar ----
  var buySection = document.getElementById("buy");
  var buyBar = null;
  if (buySection) {
    buyBar = document.createElement("div");
    buyBar.className = "buy-bar";
    var titleEl = document.querySelector(".pdp-title, .buy h2");
    var thumbSrc = (document.getElementById("pdpMain") || {}).src || "";
    // Sepete ekleme formu olmayan sayfada (ana sayfa) çubuk da ürün
    // sayfasına götürür; "Sepete Ekle" yazması yanıltıcı olurdu.
    var barLink = buySection.querySelector("[data-buy-link]");
    var barForm = buySection.querySelector('form[action*="/cart/add"]');
    var barLabel = barForm ? "Sepete Ekle" : (barLink ? barLink.textContent.trim() : "Ürünü İncele");
    buyBar.innerHTML =
      '<div class="bb-inner">' +
        (thumbSrc ? '<img class="bb-thumb" src="' + thumbSrc + '" alt="" width="44" height="44">' : "") +
        '<span class="bb-text">' +
          '<span class="bb-title">' + (titleEl ? titleEl.textContent.trim() : "") + "</span>" +
          '<span class="bb-variant"></span>' +
        "</span>" +
        '<span class="bb-price">—</span>' +
        '<button type="button" class="btn btn--accent bb-buy">' + barLabel + "</button>" +
      "</div>";
    document.body.appendChild(buyBar);
    // Gövde alt boşluğu SADECE çubuk gerçekten varsa uygulansın;
    // yoksa ana sayfanın altında boşluk kalıyordu.
    document.body.classList.add("has-buybar");
    syncBuyBar();

    // Çubuktaki buton, sayfadaki gerçek formu gönderir
    buyBar.querySelector(".bb-buy").addEventListener("click", function () {
      var form = buySection.querySelector('form[action*="/cart/add"]');
      var link = buySection.querySelector("[data-buy-link]");
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      else if (link) window.location.href = link.href;
      else buySection.scrollIntoView({ behavior: reduce ? "auto" : "smooth" });
    });
  }
  function syncBuyBar() {
    if (!buyBar) return;
    var now = document.querySelector(".bundle.is-active .now") ||
              document.querySelector(".pdp-price .now") ||
              document.querySelector(".bundle .now");
    if (now) buyBar.querySelector(".bb-price").textContent = now.textContent.trim();

    // Seçili paketin adı çubukta da görünsün — hangi paketi aldığı belirsiz kalmasın
    var vSlot = buyBar.querySelector(".bb-variant");
    if (vSlot) {
      var active = document.querySelector(".bundle.is-active .bundle-title");
      // Etiketleri (POPÜLER vb.) atıp sadece varyant adını al
      var name = "";
      if (active) {
        active.childNodes.forEach(function (n) {
          if (n.nodeType === 3) name += n.textContent;
        });
      }
      vSlot.textContent = name.trim();
    }
  }
  function toggleBuyBar() {
    if (!buyBar || !buySection) return;
    // Satın alma bölümü ekrandan yukarı çıkınca çubuk belirir
    buyBar.classList.toggle("show", buySection.getBoundingClientRect().bottom < 0);
  }
})();

/* ============ ÜRÜN SAYFASI + GERÇEK YORUMLAR ============ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Galeri buradaydı; tıklamayı aşağıdaki galeri bloğu da dinliyordu, yani
  // her tıklamada iş iki kez yapılıyordu. Tek yere taşındı.

  // ---- Adet artır/azalt ----
  document.addEventListener("click", function (e) {
    var b = e.target.closest(".qty-btn");
    if (!b) return;
    var box = b.closest("[data-qty]");
    var input = box.querySelector(".qty-val");
    var n = parseInt(input.value, 10);
    if (isNaN(n)) n = 1;
    n += parseInt(b.getAttribute("data-step"), 10);
    input.value = Math.max(1, Math.min(99, n));
  });
  document.addEventListener("change", function (e) {
    if (!e.target.matches(".qty-val")) return;
    var n = parseInt(e.target.value, 10);
    e.target.value = isNaN(n) ? 1 : Math.max(1, Math.min(99, n));
  });

  // ---- "Yorum Yaz" formunu aç/kapat ----
  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-rv-open]")) return;
    var wrap = document.getElementById("rvForm");
    if (!wrap) return;
    wrap.hidden = !wrap.hidden;
    if (!wrap.hidden) {
      wrap.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
      var first = wrap.querySelector('input[name="comment[author]"]');
      if (first) setTimeout(function () { first.focus(); }, reduce ? 0 : 400);
    }
  });

  // Hata varsa ya da gönderim başarılıysa formu açık başlat
  var rvWrap = document.getElementById("rvForm");
  if (rvWrap && rvWrap.querySelector(".rv-msg")) rvWrap.hidden = false;

  // ---- Tüm yorumları göster ----
  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-rv-more]")) return;
    document.querySelectorAll(".rv-grid .review-card.is-hidden").forEach(function (c) {
      c.classList.remove("is-hidden");
    });
    e.target.closest("[data-rv-more]").remove();
  });

  // ---- Yorum gönderimi ----
  // Puanı yorum metnine gömüp formu Shopify'a NORMAL yoldan gönderiyoruz.
  // Araya fetch ile girersek Shopify'ın görünmez CAPTCHA doğrulaması
  // çalışmıyor ve gönderim "Missing CAPTCHA token" ile reddediliyor.
  // Gönderim sonrası kullanıcı yazı sayfasına düşer; orada teşekkür
  // ekranı ve ürüne dönüş bağlantısı var (templates/article.liquid).
  var rvForm = document.getElementById("rvCommentForm");
  if (rvForm) {
    rvForm.addEventListener("submit", function () {
      var body = rvForm.querySelector('textarea[name="comment[body]"]');
      var picked = rvForm.querySelector('input[name="rv-rating"]:checked');
      if (body && picked && !/^\[\d\/5\]/.test(body.value)) {
        body.value = "[" + picked.value + "/5] " + body.value.trim();
      }
      var btn = rvForm.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = "Gönderiliyor…"; }
    });
  }
})();

/* ============ YASAL METİN PANELLERİ ============ */
/* Açma/kapama artık adres çubuğundaki parçayla (#yasal-...) ve CSS `:target`
   ile oluyor; paneller JS olmadan da çalışıyor. Buradaki iş sadece cilalama:
     • Esc ile kapatma
     • panel açıkken arka sayfanın kaydırılmaması
     • kapatırken sayfanın alt bilgiye zıplamaması
   Eskiden bütün açma/kapama JS'teydi ve bağlantılar `href="#"` idi. */
(function () {
  "use strict";
  var PANEL = /^#yasal-/;

  function openPanel() {
    var h = window.location.hash;
    if (!PANEL.test(h) || h === "#yasal-kapat") return null;
    var el = document.querySelector(h.replace(/[^#\w-]/g, ""));
    return el && el.classList.contains("legal-panel") ? el : null;
  }

  function sync() {
    var panel = openPanel();
    document.body.classList.toggle("legal-open", !!panel);
    if (panel) {
      var body = panel.querySelector(".legal-body");
      if (body) body.scrollTop = 0;
    }
  }

  window.addEventListener("hashchange", sync);
  sync();

  // Kapatma: adres çubuğundaki parçayı sil ama SAYFAYI OYNATMA.
  // Bağlantı #yasal-kapat'a gidiyor (JS yokken tarayıcı alt bilgiye götürsün
  // diye); JS varken oraya zıplamak gereksiz, olduğun yerde kalıyorsun.
  function close(e) {
    if (e) e.preventDefault();
    document.body.classList.remove("legal-open");
    if (window.history.replaceState) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    } else {
      window.location.hash = "";
    }
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-legal-close], .legal-scrim")) close(e);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && openPanel()) close();
  });
})();

/* ============ PUAN ROZETİNDEN YORUMLARA KAYDIRMA ============ */
/* Judge.me widget'ı sayfanın çok altında; rozete basınca oraya yumuşakça
   kayıyoruz. Bağlantının kendi href'i (#judgeme_product_reviews) zaten
   çalışıyor — bu sadece zıplamayı kaydırmaya çeviriyor, JS kapalıyken de
   bağlantı işini görür. */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return;
  document.addEventListener("click", function (e) {
    var link = e.target.closest("[data-scroll-to-reviews]");
    if (!link) return;
    var target = document.querySelector(link.getAttribute("href"));
    if (!target) return;   // widget henüz basılmadıysa tarayıcı kendi işini yapsın
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
})();

/* ============ SEPET: adet değişince otomatik güncelle ============ */
(function () {
  "use strict";
  var form = document.querySelector(".cart-form");
  if (!form) return;
  var timer = null;
  function submitSoon() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      // "update" adında gizli bir gönderi ekleyip formu yolla
      var hidden = document.createElement("input");
      hidden.type = "hidden"; hidden.name = "update"; hidden.value = "";
      form.appendChild(hidden);
      form.submit();
    }, 550);
  }
  form.addEventListener("click", function (e) {
    if (e.target.closest(".qty-btn")) submitSoon();
  });
  form.addEventListener("change", function (e) {
    if (e.target.matches("[data-cart-qty]")) submitSoon();
  });
})();

/* ============ SEPET: teklif kartlarından hızlı ekleme ============ */
(function () {
  "use strict";
  if (!window.fetch) return; // JS eski ise formlar normal şekilde gönderilir

  document.addEventListener("submit", function (e) {
    var form = e.target.closest(".cu-form");
    if (!form) return;

    e.preventDefault();
    var btn = form.querySelector(".cu-add");
    var label = btn ? btn.textContent : "";
    if (btn) { btn.setAttribute("aria-busy", "true"); btn.textContent = "Ekleniyor…"; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        // Sepet toplamı, kargo çubuğu ve teklifler hep birlikte değişiyor;
        // sayfayı tazelemek en güvenlisi.
        window.location.assign(window.location.pathname);
      })
      .catch(function () {
        if (btn) { btn.removeAttribute("aria-busy"); btn.textContent = label; }
        form.submit(); // fetch tutmazsa klasik gönderi
      });
  });
})();

/* ============ ÜRÜN GALERİSİ: oklar, sayaç, kaydırma, büyütme ============ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var stage = document.querySelector("[data-pdp-stage]");
  var main = document.getElementById("pdpMain");
  if (!stage || !main) return;

  var thumbs = Array.prototype.slice.call(document.querySelectorAll(".pdp-thumb"));
  var counter = document.querySelector("[data-pdp-counter]");

  // Açılıştaki görsel her zaman ilki olmayabilir: seçili varyantın kendi
  // görseli varsa Liquid onu işaretli basıyor. Sayacın ve okların doğru
  // yerden devam etmesi için başlangıcı oradan alıyoruz.
  var idx = 0;
  for (var i0 = 0; i0 < thumbs.length; i0++) {
    if (thumbs[i0].classList.contains("is-active")) { idx = i0; break; }
  }

  // Görseli değiştirmenin TEK yolu bu fonksiyon. Önceden thumb tıklaması,
  // oklar ve sayaç ayrı ayrı yerlerden güncelleniyordu; biri diğerini
  // ıskalayınca sayaç ile görünen görsel birbirini tutmuyordu.
  function show(i) {
    if (!thumbs.length) return;
    idx = (i % thumbs.length + thumbs.length) % thumbs.length;

    var t = thumbs[idx];
    thumbs.forEach(function (b) { b.classList.remove("is-active"); });
    t.classList.add("is-active");
    if (counter) counter.textContent = (idx + 1) + "/" + thumbs.length;

    var src = t.getAttribute("data-full");
    if (!src || main.getAttribute("src") === src) return;

    // Yeni görseli önce belleğe alıyoruz. Doğrudan src'yi değiştirince
    // görsel inene kadar kutu boş kalıyor, inince de bir anda beliriyordu;
    // göz bunu "görsel kaydı / zıpladı" diye algılıyor. Artık yeni görsel
    // hazır olmadan geçiş yapılmıyor.
    var pre = new Image();
    var done = false;
    function swap() {
      if (done) return;
      done = true;
      main.src = src;
      var ss = t.getAttribute("data-srcset");
      if (ss) main.srcset = ss;
      var alt = t.getAttribute("data-alt");
      if (alt) main.alt = alt;
      stage.classList.remove("is-swapping");
    }
    if (!reduce) stage.classList.add("is-swapping");
    pre.onload = swap;
    pre.onerror = swap;
    pre.src = src;
    // Görsel önbellekteyse onload beklemeden hemen geç
    if (pre.complete) swap();
  }

  function go(dir) { show(idx + dir); }

  document.addEventListener("click", function (e) {
    var t = e.target.closest(".pdp-thumb");
    if (t) {
      var i = thumbs.indexOf(t);
      if (i > -1) show(i);
      return;
    }
    var nav = e.target.closest("[data-pdp-nav]");
    if (nav) go(parseInt(nav.getAttribute("data-pdp-nav"), 10));
  });

  // ---- Paket seçilince galeri o paketin görseline geçsin ----
  // Varyanta görsel atanmamışsa (data-img-index="-1") galeri olduğu gibi
  // kalır; yanlış görsele atlamaktansa yerinde durması doğru.
  document.addEventListener("change", function (e) {
    if (!e.target.matches('.bundle input[type="radio"]')) return;
    var label = e.target.closest(".bundle");
    if (!label) return;
    var i = parseInt(label.getAttribute("data-img-index"), 10);
    if (!isNaN(i) && i > -1) show(i);
  });

  // Klavye: galeri odaktayken sol/sağ ok
  stage.addEventListener("keydown", function (e) {
    if (e.key === "ArrowLeft") { go(-1); }
    else if (e.key === "ArrowRight") { go(1); }
  });

  // Mobil kaydırma
  var x0 = null;
  stage.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener("touchend", function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
    x0 = null;
  }, { passive: true });

  // ---- Büyütme katmanı ----
  var lb = document.getElementById("pdpLightbox");
  var lbImg = document.getElementById("pdpLightboxImg");

  function openLb() {
    if (!lb || !lbImg) return;
    lbImg.src = main.src;
    lbImg.alt = main.alt || "";
    lb.hidden = false;
    document.body.classList.add("pdp-lb-open");
  }
  function closeLb() {
    if (!lb) return;
    lb.hidden = true;
    document.body.classList.remove("pdp-lb-open");
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-pdp-zoom]")) { openLb(); return; }
    if (e.target.closest("[data-pdp-lb-close]")) { closeLb(); return; }
    // Arka plana tıklanınca kapansın, görsele tıklanınca kapanmasın
    if (lb && !lb.hidden && e.target === lb) closeLb();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && lb && !lb.hidden) closeLb();
  });

})();
